<template>
    <div>
        <van-tabs v-model="subActive" type="card" color="#1989fa" sticky :offset-top="100">
            <van-tab title="核上家一押" v-if="upperBankShow&&upperBankAccess&&auditStatus==52||upperBankShow&&auditStatus>52">
                <UpperBankEdit v-if="upperBankAccess&&auditStatus==52" :applyId="applyId" ref="upperBankEdit" :bankType="'one'"></UpperBankEdit>
                <UpperBankInfo v-if="!upperBankAccess&&auditStatus>52"  :applyId="applyId" ref="upperBankInfo" :bankType="'one'"/>
            </van-tab>

            <van-tab title="核上家二押" v-if="upperBankSecondShow&&upperBankSecondAccess&&auditStatus==52||upperBankSecondShow&&auditStatus>52">
                <UpperBankEdit v-if="upperBankSecondAccess&&auditStatus==52" :applyId="applyId" ref="upperBankSecondEdit" :bankType="'second'"></UpperBankEdit>
                <UpperBankInfo v-if="!upperBankSecondAccess&&auditStatus>52"  :applyId="applyId" ref="upperBankInfoSecond" :bankType="'second'"/>
            </van-tab>

            <van-tab title="下家信息"  v-if="downBankShow&&downBankAccess&&auditStatus==52||downBankShow&&auditStatus>52">
                <DownBankEdit v-if="downBankAccess&&auditStatus==52" :applyId="applyId" ref="downBankEdit" ></DownBankEdit>
                <DownBankInfo v-if="!downBankAccess&&auditStatus>52"  :applyId="applyId" ref="downBankInfo"/>
            </van-tab>

            <van-tab title="核行附件">
                <oss-investigation
                        tabType="4"
                        pictureType="2"
                        :applyId="applyId" />
            </van-tab>

        </van-tabs>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { AUDIT_STATUS } from '@/vue/store/mutation-type'
    import { getForeclosureApplyInfo } from '@/api/loanInfo'
    import { findUpperBank  ,findDownBank } from '@/api/foreclosure'
    import { eventBus } from '../../../../vue/utils/eventBus'
    import store from '@/vue/store'
    import UpperBankInfo from './upper-bank-info'
    import UpperBankEdit from './upper-bank-edit'
    import DownBankEdit from './down-bank-edit'
    import DownBankInfo from './down-bank-info'
    import Investigation from './investigation'
    import OssInvestigation from '@/views/component/oss-investigation'
    import {mapGetters} from 'vuex'

    export default {
        name: 'verify-bank-info',
        computed: mapGetters([
            'auditStatus'
        ]),
        components: {
            UpperBankInfo,
            UpperBankEdit,
            DownBankEdit,
            DownBankInfo,
            Investigation,
            OssInvestigation
        },
        props: {
            applyId: {
                type: String,
                default: ''
            },
            upperBankAccess: {  //核对上家一押
                type: Boolean,
                default: false
            },
            upperBankSecondAccess: {  //核对上家二押
                type: Boolean,
                default: false
            },
            downBankAccess: {  //核对下家
                type: Boolean,
                default: false
            },
            upperBankShow:{  //核对上家一押任务
                type:Boolean,
                default:false
            },
            upperBankSecondShow:{  //核对上家二押任务
                type:Boolean,
                default:false
            },
            downBankShow:{  //核对下家任务
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                subActive: '0',

            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
